module.exports = __webpack_public_path__ + "img/header.fa484249.png";